<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6osP6Z/tc-custom/9781466813120.jpg?1732137008010" alt="This image is the cover for the book Walking West"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Walking West
      </h1>
      <p class="bookDescription body article font2">
        <p>About the great migration west, Edna Ferber wrote, "I am not belittling the brave pioneer men, but the sunbonnet as well as the sombrero helped to settle this glorious land of ours."  These westering foremothers take center stage in <i>Walking West</i>, Noelle Sickels's remarkable first novel of women and their families on a grueling wagon train journey across the United States.<br/><br/>In the wet spring of 1852, a small band of Indiana farm families set off for California, lured west by the promise of a better life.  The Muller party crosses treacherous rivers, slogs through mud and thunderstorms, and hauls wagons up and down mountains and over baking deserts in a seven-month journey across our raw continent.<br/><br/>Among them is Alice Muller, a reluctant traveler forced to leave home by her husband Henry's dreams of prosperity.  But the Mullers greatly underestimate the hardships they will face, and it is ultimately Alice who must draw on the deepest reserves of body and soul to lead the little group of bone-weary emigrants through their final miles.  In doing so, Alice changes from a dutiful farm wife into a woman capable of deep commitment, strong actions, and profound self-knowledge.<br/><br/>Noelle Sickels's novel takes readers across America--through Fort Laramie, Chimney Rock, the Black Hills, the Rockies, and the Sierras--and into the minds of her extraordinary characters.  Offering a woman's perspective on a historical period more often portrayed through the male icons of cowboys, outlaws, and gold seekers, <i>Walking West</i> combines history and storytelling in a novel of astonishing authenticity and emotional power.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Noëlle Sickels
      </h2>
      
      <p class="authorDescription body article">Noëlle Sickels writes historical fiction, including <I>Walking West</I>, <I>The Shopkeeper's Wife</I>, and <I>The Medium</I>. Sickels has published award-winning short stories in magazines and anthologies. A native of New Jersey, she is a retired teacher living in Los Angeles and Ojai, California with her husband and cat. Much of her non-writing time is happily taken up by her granddaughter, who also likes good stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cca19bfc